var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.prefixCls}-strategy`,attrs:{"id":"aochenStrategy"}},[_c('Separate',{attrs:{"title":"研发战略","desc":"R&D STRATEGY"}}),_c('div',{class:`${_vm.prefixCls}-strategy-content`},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }